import React from "react";
//import styled from 'styled-components';

import Logo from "../components/Logo";

export default function Footer() {
  return (
    <>
      <footer className="bg-gray-700 py-6">
        <div className="md:flex-no-wrap font-inter container mx-auto flex flex-col flex-wrap px-5 md:flex-row md:items-center lg:items-start">
          <a className="title-font flex w-full items-center justify-center text-center font-medium text-gray-900 md:w-1/4 md:justify-start">
            <Logo />
          </a>
          <div className="mt-8 w-full flex-grow text-white md:mt-0 md:w-1/4">
            <p className="mb-1 text-xl font-semibold leading-tight">Kontakt</p>
            <p className="text-lg leading-tight text-white">
              Univerza v Mariboru
              <br />
              Fakulteta za varnostne vede
              <br />
              Kotnikova ulica 8, Ljubljana
              <br />
              e-pošta:{" "}
              <a
                href="mailto:dnevi.varstvoslovja@um.si"
                className="text-dv2021-300 underline"
              >
                Dnevi.Varstvoslovja@um.si
              </a>
            </p>
          </div>
          <div className="mt-8 w-full md:w-2/4 lg:mt-0">
            <p className="mb-1 text-xl font-semibold leading-tight text-white">
              Programsko-organizacijski odbor
            </p>
            <p className="text-lg leading-tight text-white">
              doc. dr. Maja Modic (predsednica), izr. prof. dr. Benjamin
              Flander, prof. dr. Branko Lobnikar, doc. dr. Tinkara Pavšič
              Mrevlje, Anja Zahirović, Barbara Erjavec, Aleksander Podlogar,
              Violeta Malić, Gregor Bec.
            </p>{" "}
          </div>
        </div>
      </footer>
    </>
  );
}
